<template>
  <div class="app-container">
    <list ref="list" :can-price="$permission.canPrice()">
        <template slot="toolbar-right" v-if="$permission.canWrite()">
            <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
            <el-button type="primary" @click="onGenerate" v-if="IsOutPicking">生成耗料单</el-button>
            <el-dropdown style="margin-left: 10px;" @command="handleCommand">
              <el-button type="primary">添加注塑入库单<i class="el-icon-arrow-down el-icon--right"></i></el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="0">按胶件入库</el-dropdown-item>
                <el-dropdown-item :command="1">按模入库</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
        </template>
        <template slot="column">
            <el-table-column label="操作" fixed="right" align="center" width="100">
                <template slot-scope="{row}">
                    <el-button v-if="$permission.canWrite() && row.Status !== 2" @click.stop="edit(row)" type="text" >
                      编辑
                    </el-button>
                     <el-button v-if="$permission.canReview() && row.Status == 2"   type="text" @click.stop="edit(row)">查看</el-button>
                       <el-button type="text" @click="onPrint(row)">打印</el-button>
                </template>
            </el-table-column>
      </template>
    </list>
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from '@/components/business/stock/outsourcedwarehousing/list'


export default {
  mixins: [curdMixins],
  components: {
    list,
  },
  data(){
    return {
      api: require("@/api/stock/stInDoc").default,
      optionApi: require("@/api/sy/option").default,
      IsOutPicking:false
    }
  },
  mounted() {
    this.optionApi.getInitialSetting().then((res) => {
      if (res.Code === 0) {
        this.IsOutPicking = res.Data.IsOutPicking;
      }
    });
  },
  methods: {
    edit(row){
       let id = row.DocId;
       this.api.info(id).then(res => {
        if(res.Code === 0){
          if (row.ProcessingType == "注塑") {
            console.log('row.StorageMethod',row.StorageMethod)
            if (row.StorageMethod == 0) {
              //按胶件入库
              this.toURL({ name: 'editoutsourcedwarehousing1', params: { type: 'edit', data: res.Data } });
            } else {
              //按模入库
              this.toURL({ name: 'editoutsourcedwarehousing2', params: { type: 'edit', data: res.Data } });
            }
          } else {
            this.toURL({ name: 'editoutsourcedwarehousing', params: { type: 'edit', data: res.Data } })
          }
        }else{
          this.$message({type: 'warning', message: res.Msg})
        }
       })

       
    },
    create(){
      
      this.toURL({
        name: 'editoutsourcedwarehousing',
        params: {
          type: 'create'
        }
      })

    },
    handleCommand(value) {
      if (value == 0) {
        //按胶件入库
        this.toURL({ name: 'editoutsourcedwarehousing1', params: { type: 'create' } });
      } else {
        //按模入库
        this.toURL({ name: 'editoutsourcedwarehousing2', params: { type: 'create' } });
      }
    },
     onPrint(row) {
      let newpage = this.$router.resolve({
        path: "/outsourcedwarehousingPrint?id=" + row.DocId,
      });
      window.open(newpage.href, "_blank");
    },
    toURL(o){
      this.$router.push(o)
    },
    /** 生成耗料单 */
    onGenerate() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要生成耗料单的数据");
        return;
      }
      this.$confirm("确认生成耗料单所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let Ids = rows.map((item) => item.DocId);
        this.api.examineUseDoc({ Ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("操作成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
          this.reload();
        }
      });
      }).catch(() => { });
    }
  }
  
};
</script>